import React, { useState } from 'react'
import { Col } from 'react-bootstrap'
import { makeStyles, Button, Tooltip, IconButton, Dialog, Card, CardActionArea } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import { COLORES } from '../../../../config/colores'
import { reduxForm, formValueSelector, Field, change, arrayRemove, arrayPush } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { connect } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import FindReplaceIcon from '@material-ui/icons/FindReplace'
import CampoExportadorSimulacion from './CampoExportadorSimulacion'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'
import EntitySelect from '../../../Forms/SharedComponents/containers/EntitySelect'
import { saveSimulacionExportadores } from '../../actions/listados'
import ConfirmacionGuardadoSimulacion from '../estimacionStock/ConfirmacionGuardadoSimulacion'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { parseEntityName } from '../../../../models/entity'

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: '8px',
    width: '100%',
    margin: '8px',
    display: 'flex',
    justifyContent: 'center',
    border: '6px solid',
    borderColor: COLORES.grey.mediumDark
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8
  },
  headerSticky: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: COLORES.grey.dark,
    color: 'white'
  },
  footerSticky: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1000,
    backgroundColor: 'white',
    padding: '8px',
    display: 'flex',
    justifyContent: 'center'
  },
  campoExportador: {
    border: `2px solid ${COLORES.grey.mediumDark}`,
    borderRadius: '8px',
    padding: '12px'
  }
}))

const MAX_SIMULACIONES = 4

function SimulacionExportador (props) {
  const { exportadores, change: formChange, simulacionActiva, removeSimulacion, saveSimulacionExportadores, exportadoresActivos } = props
  const classes = useStyles()
  // const [exportadorSelected, setExportadorSelected] = useState(null)
  const [open, setOpen] = useState(false)
  const [showConfirmacion, setShowConfirmacion] = useState(false)

  const handleRemove = () => {
    removeSimulacion(simulacionActiva)
    formChange('simulacionActiva', undefined)
    handleClose()
  }

  const handleReplace = (index) => {
    formChange(`exportadoresSimulacion[${index}].exportador`, null)
    formChange(`exportadoresSimulacion[${index}].cereal`, null)
  }

  const addSimulacion = () => {
    const newSimulacion = {
      exportador: null,
      cereal: null
    }

    props.addSimulacion(newSimulacion)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const updateSimulacionActiva = (index) => {
    if (simulacionActiva !== index) {
      formChange('simulacionActiva', index)
    }
  }

  const handleSave = () => {
    saveSimulacionExportadores()
    setShowConfirmacion(false)
  }

  // const buttonDisabled = (index, e) => {
  //   const simulacionExportador = props.simulacionesPersistidas.filter((sim) => sim.exportador === e.exportador)
  //   return simulacionExportador.length === 0
  // }

  const buttonDisabled = () => {
    const simulacionExportador = props.simulacionesPersistidas.filter((sim) => sim.exportador !== 'POOL')
    return simulacionExportador.length === 0
  }

  const handleOnSelected = (e, index) => {
    formChange(`exportadoresSimulacion[${index}].exportador`, e)
  }

  const isDisabled = buttonDisabled()

  const renderSimulaciones = () => {
    return (
      <>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        {exportadores && exportadores.map((e, index) => {
          if (!e) {
            return null
          }

          // const isDisabled = buttonDisabled(index, e)

          return (
            <Card
              key={e.exportador || index}
              className={classes.container}
              style={{
                alignItems: 'flex-start',
                minHeight: '30vh',
                // maxHeight: '60vh',
                overflow: 'scroll'
              }}
            >
              <CardActionArea
                onClick={() => { updateSimulacionActiva(index) }} disableRipple component='div'>
                <Field
                  name={`exportadoresSimulacion[${index}].cereal`}
                  component='input'
                  type='hidden'
                />
                <Col md={12} className={`${classes.header} ${classes.headerSticky}`}>
                  <p style={{ marginBottom: 0, fontWeight: 'bold' }}>Simulación {index + 1}</p>
                  {!e.exportador
                    ? <div key={index} className='animation-pulse' style={{ marginTop: 0, width: '60%' }}>
                      <div style={{ margin: '8px' }}>
                        <EntitySelect
                          name={`exportadoresSimulacion[${index}].exportador`}
                          label='Seleccione un exportador'
                          entity='exportador'
                          value={'Seleccione un exportador'}
                          labelKeys={['razonSocial', 'cuit']}
                          onChange={() => {}}
                          orderBy={'razon_social'}
                        />
                      </div>

                      {exportadoresActivos.map((e) => {
                        const activo = exportadores.filter(exp => exp.exportador === e)
                        const isActivo = activo.length > 0
                        if (isActivo) {
                          return null
                        }

                        return (
                          <Button
                            key={e}
                            variant='outlined'
                            style={{
                              backgroundColor: 'white',
                              color: COLORES.grey.dark,
                              margin: '8px'
                            }}
                            onClick={() => { handleOnSelected(e, index) }}
                          >
                            {parseEntityName(e)}
                          </Button>
                        )
                      })
                      }
                    </div>
                    : <>
                      {/* Simulación para el exportador seleccionado */}
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <p style={{ fontWeight: 'bold', padding: 0, margin: 0 }}>{e.exportador}</p>
                        <Tooltip title={'Seleccionar otro exportador'}>
                          <IconButton onClick={() => { handleReplace(index) }}>
                            <FindReplaceIcon style={{ color: COLORES.grey.light }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </>

                  }
                  <Dialog
                    open={open}
                    onClose={handleClose}
                    maxWidth='lg'
                  >
                    <DialogView
                      cancelCallback={handleClose}
                      confirmCallback={handleRemove}
                      title='Eliminar simulación de exportador'
                      content={<DialogConfirmacionContent
                        message='Los datos que no hayan sido guardados se perderan. ¿Esta seguro que desea eliminar la simulación?'
                      />
                      }
                    />
                  </Dialog>
                  <Tooltip title='Eliminar simulación'>
                    <IconButton onClick={handleOpen} >
                      <DeleteIcon style={{ color: COLORES.grey.light }} />
                    </IconButton>
                  </Tooltip>
                </Col>
                {e.exportador &&
                  <div style={{ paddingBottom: '40px' }}>
                    <CampoExportadorSimulacion
                      index={index}
                      exportador={e.exportador}
                      exportadores={exportadores}
                      change={formChange}
                    />
                  </div>
                }
              </CardActionArea>
            </Card>
          )
        })}
      </>
    )
  }

  const cantSimulaciones = exportadores ? exportadores.length : 0

  return (
    <>
      {props.dataExportadoresOk
        ? <>
          {showConfirmacion &&
          <ConfirmacionGuardadoSimulacion
            simulaciones={props.simulacionesPersistidas}
            openSave={showConfirmacion}
            handleSave={handleSave}
            handleCloseSave={() => { setShowConfirmacion(false) }}
            exportadores={exportadores}
          />
          }
          { !isDisabled &&
          <div className={classes.footerSticky}>
            <Button
              variant='contained'
              style={{
                backgroundColor: COLORES.violet,
                color: 'white',
                fontWeight: 'bold'
              }}
              onClick={() => setShowConfirmacion(true)}
            >
                        Guardar simulación para exportadores
            </Button>
          </div>
          }
          {renderSimulaciones()}
          {/* Agregar tarjeta de simulación limitado por MAX_SIMULACIONES */}
          {cantSimulaciones < MAX_SIMULACIONES &&
          <Button
            onClick={() => { addSimulacion() }}
            className={classes.container}
            style={{ backgroundColor: COLORES.grey.dark, alignItems: 'center', minHeight: '18vh' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <AddIcon style={{ color: 'white', fontSize: '5rem' }} />
              <p style={{ color: 'white' }}>Agregar simulación</p>
              <span style={{ color: COLORES.grey.light }}>{cantSimulaciones + 1} de {MAX_SIMULACIONES}</span>
            </div>
          </Button>
          }
        </>
        : <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          height: '100%'
        }}
        >
          <div className='loader' />
          <p style={{ fontSize: '1rem' }}>Preparando datos para las simulaciones</p>
        </div>
      }
    </>
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state) => ({
  exportadores: selector(state, 'exportadoresSimulacion'),
  exportadoresActivos: state.stock.exportadoresActivos,
  simulacionActiva: selector(state, 'simulacionActiva'),
  dataExportadoresOk: state.stock.receiveEstimacionExportadores,
  simulacionesPersistidas: state.stock.simulacionesPersistidas
})

const mapActionsToProps = {
  removeSimulacion: (index) => arrayRemove(FORM_ESTIMACION_STOCK, 'exportadoresSimulacion', index),
  addSimulacion: (simulacion) => arrayPush(FORM_ESTIMACION_STOCK, 'exportadoresSimulacion', simulacion),
  formChange: change,
  saveSimulacionExportadores
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

const MemoizedSimulacionExportador = React.memo(SimulacionExportador)
const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(MemoizedSimulacionExportador))
